module.exports = __webpack_public_path__ + "img/pauli-y-root-12.099e7a99.svg";